<div class="content" *ngIf="!isLoading" data-cy="dashboard">
  <ng-container *ngIf="canViewStats; else noStats">
    <section class="dashboard">
      <app-dashboard-date-tabs
        (rangeChange)="onRangeChange($event)"
        (tierChange)="onTierChange($event)"
      ></app-dashboard-date-tabs>

      <p *ngIf="error$ | async" class="dashboard-error" data-cy="dashboard-error">
        Failed to load the activity report. Please try again.
      </p>

      <app-dashboard-overview-panel
        header="SALES OVERVIEW"
        [tiles]="(tiles$ | async) ?? []"
      ></app-dashboard-overview-panel>

      <app-dashboard-merchant-table
        [rows]="rows$ | async"
        (merchantSelect)="onMerchantSelect($event)"
      ></app-dashboard-merchant-table>

      <app-dashboard-income-chart
        [(visible)]="drillVisible"
        [row]="selectedRow"
        [fromIso]="currentRange?.from ?? null"
        [toIso]="currentRange?.to ?? null"
      ></app-dashboard-income-chart>
    </section>
  </ng-container>

  <ng-template #noStats>
    <section class="panel dashboard" data-cy="dashboard-no-stats">
      <h1>Dashboard</h1>
      <p>No sales overview available for your account.</p>
    </section>
  </ng-template>
</div>
